export class LicensePlate {
  id!: string;
  numberPlate!: string;
  startDate?: string;
  endDate?: string;
}

export type LicensePlateRequest = Omit<LicensePlate, 'id'>;

export class LicensePlates {
  personal!: LicensePlate[];
  rental!: LicensePlate[];
  company!: LicensePlate[];
}
